import { render, staticRenderFns } from "./VisualizarProdutosCotacaoDialog.vue?vue&type=template&id=7245b65a"
import script from "./VisualizarProdutosCotacaoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./VisualizarProdutosCotacaoDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports